import { useMemo } from 'react'

import { ProfileType } from '@modules/search/types'
import { useQuery } from '@tanstack/react-query'

import alertsApi from '../api'
import { ProfileAlert } from '../types'

const useAlertDataForProfiles = (profiles: { id: number; '@type': ProfileType }[] = [], enabled = Boolean(profiles.length)) => {
  const { data: profileAlerts } = useQuery({
    queryKey: [alertsApi.fetchProfilesAlerts.key, profiles.map(profile => profile.id)],
    queryFn: () => alertsApi.fetchProfilesAlerts.fn(profiles),
    enabled,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
  })

  const profilesAlertsMap = useMemo<Record<string, ProfileAlert>>(() => {
    if (!profileAlerts) {
      return {}
    }

    return profileAlerts.profiles.reduce<Record<string, ProfileAlert>>(
      (acc, profileAlert) => ({ ...acc, [profileAlert.searchDocId as number]: profileAlert }),
      {},
    )
  }, [profileAlerts])

  return { profileAlerts, profilesAlertsMap }
}

export default useAlertDataForProfiles
